/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  new WOW().init()

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper-fade', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  new Swiper('.sp-swiper-fade1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find('.sp-text').each(function () {
          this.style.animation = 'none'
        })
        const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
        if (spText) {
          spText.style.animation = 'none'

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`
        }
      },
    },
  })

  new Swiper('.sp-swiper0', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  })
  function isMobile() {
  return window.innerWidth < 768; // 可以根据需要调整阈值
}
  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    let imgList = [
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20251121-p1.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20251121-p2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1_1.jpg?v=1768355952',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/2_1_d910f858-e390-400e-958b-0349c7b6841d.jpg?v=1768355953',
      // 'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1175_5.png?v=1765512174',

      // 'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20251121-p4.png',
      // 'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20251121-p3.png',
      //  'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1175_27.webp?v=1765940435',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1175_26.webp?v=1765940435',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1175_23.webp?v=1765940435',
      // 'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1128lan.jpg?v=1764670547',
      // 'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/1128lv.jpg?v=1764670547',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/2026_1_14_2_5b641195-a2a5-423b-be1c-5c66511842e3.jpg?v=1768355952',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/2026_1_14_1_034473e5-d1e7-4f6d-bc60-aeb30a71bf96.jpg?v=1768355953',
    ];

    preloadImages(imgList)
    lazyLoadImages()

    $(".sp-mobile .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
  
      // let colorOptions = $("#sp-color .sp-option.active").index();
      let typeOptions = $(".sp-mobile .sp-type .sp-option.active").index();
      let bindsOptions = $(".sp-mobile .sp-binds .sp-option.active").index();
      // let colorOptions = $(".sp-mobile .sp-color .sp-option.active").index();
      let _index = typeOptions + bindsOptions * 4;
    //   let _index = typeOptions;
    console.log(_index,'99999999')
  
      $(".product-part.sp-mobile .sp-img-p")
        .attr('src', imgList[_index])

      if (bindsOptions == 1) {
        $(".product-part.sp-mobile .sp-img-p").css('clip-path', 'inset(100px 0px)')
      } else {
        $(".product-part.sp-mobile .sp-img-p").css('clip-path', 'inset(0 0 0 0)')
      }
  
      $(this).parent().prev().find("span").html($(this).text());
      // $(".product-part.sp-mobile .option-title span").html($(this).text());
      // _swiper.slideToLoop(_index);
      const productPar = $(this).closest('.product-part')
      changePrice(productPar)
    });
  
    $(".sp-pc .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
  
      // let colorOptions = $("#sp-color .sp-option.active").index();
      let typeOptions = $(".sp-pc .sp-type .sp-option.active").index();
      let bindsOptions = $(".sp-pc .sp-binds .sp-option.active").index();
      // let colorOptions = $(".sp-pc .sp-color .sp-option.active").index();
      let _index = typeOptions + bindsOptions * 4;
    //   let _index = typeOptions;
  
      $(".product-part.sp-pc .sp-img-p")
        .attr('src', imgList[_index])
  
      $(this).parent().prev().find("span").html($(this).text());
      // $(".product-part.sp-pc .option-title span").html($(this).text());
      // _swiper.slideToLoop(_index);
      const productPar = $(this).closest('.product-part')
      changePrice(productPar)
    });

    function debounce(func, delay = 300) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
   function goShopping() {
     // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
     const isMobileVal = isMobile()
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
       
        const targetElement = isMobileVal ? document.getElementById('shopping') :  document.getElementById('shopping');// 获取跳转目标节点
        const offsetTop = 
            document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-mobile.sp-nav").height()
            : targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? 20 : 40

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })
   }
   goShopping()
    window.addEventListener('resize', debounce(goShopping));
    // var links = document.querySelectorAll('a[href^="#shopping"]')
    // links.forEach(function (link) {
    //   link.addEventListener('click', function (event) {
    //     event.preventDefault() // 阻止默认的跳转行为
    //     // 方式一
    //     const targetElement = document.getElementById('shopping1') // 获取跳转目标节点
    //     const offsetTop = targetElement.offsetTop
    //     let sptop = document.body.clientWidth <= 1080 ? 20 : 40

    //     window.scroll({
    //       top:
    //         offsetTop * $('div#root').css('zoom') -
    //         sptop * $('div#root').css('zoom'),
    //       behavior: 'smooth', // 使用 smooth 实现平滑滚动
    //     })
    //   })
    // })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let sp_price1 = window.product[0].price / 100
  let sp_price2 = window.product[0].compare_at_price / 100

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2).replace(".",',')
  }
  $('.sp-mobile .sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    const productPar = $(this).closest('.product-part')
    changePrice(productPar)
  })
  $('.sp-mobile .sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    const productPar = $(this).closest('.product-part')
    changePrice(productPar)
  })

  $('.sp-pc .sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    const productPar = $(this).closest('.product-part')
    changePrice(productPar)
  })
  $('.sp-pc .sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    const productPar = $(this).closest('.product-part')
    changePrice(productPar)
  })

  // $('.sp-btn-style').click(function () {
  //   let num = $(this).siblings('.sp-quality-row').find('.addGroup input').val()
  //   let id = $(this).closest(".product-part").find('.sp-option.active').data("id");
  //   window.location.href = '/cart/' + id + ':' + num
  // })
  
  let prods = window.product
  function getCur(productPar) {
    console.log(productPar)
    let type = productPar.find('#sp-type div.active').attr('data-val')
    let binds = productPar.find('#sp-binds div.active').attr('data-val')
    console.log(type, binds)
    return prods.filter(item => item.option1 == type && item.option3 == binds)[0]
  }
  function changePrice(productPar) {
    let num = productPar.find('#calcNumber').val()
    let price = ((getCur(productPar).price * num) / 100).toFixed(2)
    let compare = ((getCur(productPar).compare_at_price * num) / 100).toFixed(2)
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    let off_font = 100 - Math.ceil((getCur(productPar).price / getCur(productPar).compare_at_price) * 100);

    if (productPar.hasClass('sp-mobile')) {
      productPar.find('#sp_price1').html(price)
      productPar.find('#sp_price2').html(compare)
    } else {
      productPar.find('#sp_price3').html(price)
      productPar.find('#sp_price4').html(compare)
    }
    
    productPar.find('.sp-percent').html(off_font)
  }

  $('.sp-btn-style').click(function(){
    const productPar = $(this).closest('.product-part')
    let num = $(this).siblings('.sp-quality-row').find('.addGroup input').val()
    let id = getCur(productPar).id
    window.location.href = '/cart/' + id + ':' + num
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }

  // 头部背景色随滚动变化
  function updateHeaderBackground() {
    const scrollTop = $(window).scrollTop()
    const headerInner = $('.sp-mobile .header-inner')
    const headerInnerPC = $('.sp-pc .header-inner')

    if (scrollTop > 0) {
      headerInner.css('background-color', '#ffffff')
      headerInnerPC.addClass('header-inner-fixed')
      headerInnerPC.removeClass('header-inner-absolute')
      $('.sp-pc .header-inner .sp-menu-item').css('color', '#000000')
      $('.sp-pc .sp-cart .sp-icon').attr(
        'src',
        'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20251121-cart.png'
      )
      $(".sp-pc .sp-logo-pc").attr('src',"//emiliyc.com/cdn/shop/files/logo__1.png?v=1667018901")
    } else {
      headerInner.css('background-color', 'transparent')
      headerInnerPC.addClass('header-inner-absolute')
      headerInnerPC.removeClass('header-inner-fixed')
      $('.sp-pc .header-inner .sp-menu-item').css('color', '#FFFFFF')
      $('.sp-pc .sp-cart .sp-icon').attr(
        'src',
        'https://cdn.shopify.com/s/files/1/0816/1201/3889/files/20251121-cart-pc.png'
      )
      $(".sp-pc .sp-logo-pc").attr('src',"https://cdn.shopify.com/s/files/1/0661/6147/5823/files/logo_27fac1f5-73fb-45e7-936f-5b6e49dfaa3d.png?v=1765940069")
    }
  }

  // 页面加载时检查一次
  updateHeaderBackground()

  $(window).scroll(function () {
    updateHeaderBackground()

    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  })

  $(function () {
    // 购物车加购动效
    $('.sp-mobile .cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-mobile .sp-cart .num').show()
      setTimeout(function () {
        $('.sp-mobile .cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-mobile .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-mobile .sp-cart').removeClass('on')
      }, 500)
    })

    $('.product-part.sp-mobile .cart-btn').click(function () {
      let spNum = $('.product-part.sp-mobile #calcNumber')[0].value
      const productPar = $(this).closest('.product-part')

      var data = {
        id: getCur(productPar).id,
        quantity: spNum,
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('.sp-mobile .cardNum').each(function () {
              $(this).html(result.item_count)
            })
          })
        },
        dataType: 'json',
      })

      // $("#calcNumber").val(1);

      $('.cardNum').removeClass('sp-gray')
      // handleAddToCart(initNum);

      // var imgs = $(".product-part .swiper-slide-active").find("img");
      var imgs = $('.product-part.sp-mobile .sp-img-p.active')

      imgs.each(function () {
        var $img = $(this)
        var flyer = $img[0].cloneNode(true)
        flyer.classList.add('sp_clone')

        $('.product-part.sp-mobile').append(flyer)
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: '#e7e9ef',
          position: 'fixed',

          top: $img[0].offsetTop,
          left: $img.offset().left,
          'z-index': 99,
        })

        let finish = $('.sp-btn-style2.sp-mobile .sp-cart')

        $(flyer).animate(
          {
            top: $('.sp-btn-style2')[0].offsetTop,
            left:
              $('.sp-btn-style2 .sp-area2')[0].offsetLeft +
              finish.width() / 2 +
              80,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      })
    })
  })

  // PC
  $(function () {
    // 购物车加购动效
    $('.sp-pc .cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-pc .sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.sp-pc .cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-pc .sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-pc .sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })

    $('.product-part.sp-pc .cart-btn').click(function () {
      let spNum = $('.product-part.sp-pc #calcNumber')[0].value
      const productPar = $(this).closest('.product-part')
      var data = {
        id: getCur(productPar).id,
        quantity: spNum,
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('.sp-pc .cardNum').each(function () {
              $(this).html(result.item_count)
            })
          })
        },
        dataType: 'json',
      })

      // $("#calcNumber").val(1);

      $('.cardNum').removeClass('sp-gray')
      // handleAddToCart(initNum);

      // var imgs = $(".product-part .swiper-slide-active").find("img");
      var imgs = $('.product-part.sp-pc .sp-img-p.active')

      imgs.each(function () {
        var $img = $(this)
        var flyer = $img[0].cloneNode(true)
        flyer.classList.add('sp_clone')

        $('.product-part.sp-pc').append(flyer)
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: '#e7e9ef',
          position: 'fixed',

          top: $img[0].offsetTop,
          left: $img.offset().left,
          'z-index': 99,
        })

        let finish = $('.sp-pc .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      })
    })
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
